import React, { useState } from 'react';
import { FaGithub, FaLinkedin, FaWhatsapp, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', isError: false });
  const [showSuccess, setShowSuccess] = useState(false);

  const footerStyle = {
    backgroundColor: '#ffffff',
    color: '#000000',
    padding: '3rem 2rem',
    borderTop: '1px solid #eaeaea',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const contentStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'wrap',
    marginBottom: '2rem',
  };

  const sectionStyle = {
    flex: '1',
    minWidth: '250px',
    margin: '1rem',
  };

  const headingStyle = {
    fontSize: '1.2rem',
    fontWeight: '600',
    marginBottom: '1.5rem',
    position: 'relative',
    display: 'inline-block',
  };

  const headingUnderlineStyle = {
    position: 'absolute',
    bottom: '-8px',
    left: '0',
    width: '40px',
    height: '3px',
    backgroundColor: '#000000',
  };

  const linkStyle = {
    display: 'block',
    color: '#555555',
    textDecoration: 'none',
    margin: '0.8rem 0',
    transition: 'all 0.3s ease',
    ':hover': {
      color: '#000000',
      paddingLeft: '5px',
    }
  };

  const socialLinksStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '1.5rem',
    margin: '1.5rem 0',
  };

  const socialIconStyle = {
    fontSize: '1.5rem',
    color: '#555555',
    transition: 'all 0.3s ease',
    ':hover': {
      color: '#000000',
      transform: 'translateY(-3px)',
    }
  };

  const copyrightStyle = {
    textAlign: 'center',
    marginTop: '2rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid #eaeaea',
    color: '#777777',
    fontSize: '0.9rem',
  };

  const newsletterFormStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '1rem',
  };

  const inputStyle = {
    padding: '0.5rem',
    border: '1px solid #eaeaea',
    borderRadius: '4px',
    fontSize: '0.9rem',
    outline: 'none',
    transition: 'border 0.3s ease',
    ':focus': {
      border: '1px solid #000000',
    }
  };

  const buttonStyle = {
    padding: '0.5rem 1rem',
    backgroundColor: '#000000',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    transition: 'all 0.3s ease',
    ':hover': {
      backgroundColor: '#333333',
    },
    ':disabled': {
      backgroundColor: '#cccccc',
      cursor: 'not-allowed',
    }
  };

  const messageStyle = (isError) => ({
    color: isError ? '#ff0000' : '#008000',
    fontSize: '0.8rem',
    marginTop: '0.5rem',
    textAlign: 'center',
  });

 const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ text: 'الرجاء إدخال البريد الإلكتروني', isError: true });
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage({ text: 'البريد الإلكتروني غير صالح', isError: true });
      return;
    }

    setLoading(true);
    setMessage({ text: '', isError: false });

    try {
      const response = await fetch('https://my-portfoli-backed.onrender.com/api/newsletter/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        // استخراج رسالة الخطأ من الاستجابة سواء كانت من data.message أو data.error
        const errorMessage = data.message || data.error || 'حدث خطأ غير متوقع أثناء الاشتراك';
        throw new Error(errorMessage);
      }

      setMessage({ text: data.message, isError: false });
      setShowSuccess(true);
      setEmail('');
      
      setTimeout(() => {
        setShowSuccess(false);
        setMessage({ text: '', isError: false });
      }, 5000);
    } catch (error) {
      setMessage({ 
        text: error.message || 'حدث خطأ أثناء الاتصال بالسيرفر',
        isError: true 
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <div style={contentStyle}>
          {/* معلومات الاتصال */}
          <div style={sectionStyle}>
            <h3 style={headingStyle}>
              تواصل معنا
              <span style={headingUnderlineStyle}></span>
            </h3>
            <a href="mailto:abdualrhmanmahrez@gmail.com" style={linkStyle}>abdualrhmanmahrez@gmail.com</a>
            <a href="tel:+967778340172" style={linkStyle}>+778 340  172</a>
            <p style={{ color: '#555555', margin: '0.8rem 0' }}>العنوان: صنعاء,  شارع الستين الشمالي</p>
          </div>

          {/* روابط سريعة */}
          <div style={sectionStyle}>
            <h3 style={headingStyle}>
              روابط سريعة
              <span style={headingUnderlineStyle}></span>
            </h3>
            <a href="/" style={linkStyle}>الرئيسية</a>
            <a href="/blogs" style={linkStyle}>المدونة</a>
            <a href="/projects" style={linkStyle}>اعمالي</a>
            <a href="/books" style={linkStyle}>المكتبة</a>
          </div>

          {/* وسائل التواصل الاجتماعي */}
          <div style={sectionStyle}>
            <h3 style={headingStyle}>
              تابعنا
              <span style={headingUnderlineStyle}></span>
            </h3>
            <div style={socialLinksStyle}>
              <a href="https://github.com/DUHUM3" aria-label="GitHub" style={socialIconStyle}>
                <FaGithub />
              </a>
              <a href="https://www.linkedin.com/in/abdualrhman-mehrez-340878373/" aria-label="LinkedIn" style={socialIconStyle}>
                <FaLinkedin />
              </a>
              <a href="https://wa.me/967778340172?text=مرحبًا،%20أرغب%20في%20الاستفسار%20عن%20خدماتك" aria-label="WhatsApp" style={socialIconStyle}>
                <FaWhatsapp />
              </a>
              <a href="https://www.instagram.com/_3_xi/" aria-label="Instagram" style={socialIconStyle}>
                <FaInstagram />
              </a>
            </div>
            <p style={{ color: '#555555', textAlign: 'center' }}>
              اشترك في نشرتي البريدية للحصول على آخر التحديثات
            </p>
            
            <form onSubmit={handleSubmit} style={newsletterFormStyle}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="أدخل بريدك الإلكتروني"
                style={inputStyle}
                disabled={loading}
              />
              <button 
                type="submit" 
                style={buttonStyle}
                disabled={loading || showSuccess}
              >
                {loading ? 'جاري الإرسال...' : showSuccess ? 'تم الاشتراك!' : 'اشترك الآن'}
              </button>
              {message.text && (
                <p style={messageStyle(message.isError)}>
                  {message.text}
                </p>
              )}
            </form>
          </div>
        </div>

        {/* حقوق النشر */}
        <div style={copyrightStyle}>
          <p>© {new Date().getFullYear()} جميع الحقوق محفوظة | تم التطوير بواسطة <span style={{ fontWeight: '600' }}>عبدالرحمن</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;